import { createSlice } from "@reduxjs/toolkit";
import { addAndEditStationAminityAPI } from "../../actions/stations/addStationAminityList";

const initialState = {
  stationAminities: {},
  loading: false,
  error: { code: "", message: "" },
};

const addStationAminitiesListSlice = createSlice({
  name: "addSationAmenitiesList",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAndEditStationAminityAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addAndEditStationAminityAPI.fulfilled, (state, action) => {
        state.stationAminities = action.payload.data;
        state.loading = false;
      })
      .addCase(addAndEditStationAminityAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export default addStationAminitiesListSlice.reducer;
